import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const loginAction = createAsyncThunk('auth/login', async ({ phone, password }, { rejectWithValue }) => {
  try {
    const res = await api.post('/auth/login/', { phone, password });
    localStorage.setItem('token', res.data.token);
    return res.data;
  } catch (e) {
    return rejectWithValue(e.response?.data?.error || 'Erreur');
  }
});

export const loadToken = createAsyncThunk('auth/loadToken', async () => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No token');
  try {
    const res = await api.get('/auth/me/', {
      headers: { Authorization: `Token ${token}` },
    });
    return { token, user: res.data };
  } catch (e) {
    localStorage.removeItem('token');
    throw e;
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: { user: null, token: null, loading: false, error: null },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem('token');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAction.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(loginAction.fulfilled, (s, a) => {
        s.loading = false;
        s.token = a.payload.token;
        s.user = a.payload.user;
      })
      .addCase(loginAction.rejected, (s, a) => { s.loading = false; s.error = a.payload; })
      .addCase(loadToken.fulfilled, (s, a) => { s.token = a.payload.token; s.user = a.payload.user; })
      .addCase(loadToken.rejected, (s) => { s.token = null; });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
